export enum QualityControlDocumentType {
  AppraisalReport = 1,
  AppraisalCertification = 2,
  ValorationReport = 3,
  Others = 4,
  QualityControl = 5
}

export const QualityControlDocumentTypeLabel: Record<QualityControlDocumentType, string> = {
  [QualityControlDocumentType.AppraisalReport]: 'Informe de tasación',
  [QualityControlDocumentType.AppraisalCertification]: 'Certificado de tasación',
  [QualityControlDocumentType.ValorationReport]: 'Informe de valoración',
  [QualityControlDocumentType.Others]: 'Otros',
  [QualityControlDocumentType.QualityControl]: 'Control de calidad'
};
